import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { NavigationCancel, NavigationEnd, Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { KTUtil } from '../../../../../dist/metronic1/js/components/util';
import KTLayoutAsideToggle from '../../../../../dist/metronic1/js/layout/base/aside-toggle';
import KTLayoutStickyCard from '../../../../../dist/metronic1/js/layout/base/sticky-card';
import KTLayoutStretchedCard from '../../../../../dist/metronic1/js/layout/base/stretched-card';
import KTLayoutBrand from '../../../../../dist/metronic1/js/layout/base/brand';
import KTLayoutAside from '../../../../../dist/metronic1/js/layout/base/aside';
import KTLayoutAsideMenu from '../../../../../dist/metronic1/js/layout/base/aside-menu';
import KTLayoutQuickUser from '../../../../../dist/metronic1/js/layout/extended/quick-user';
import { LayoutService } from '../../../services/layout.service';
import { LayoutStateService } from '../../../services/layout-state.service';
import { LazyLoadService, LOADING_STRATEGY } from '@abp/ng.core';
import { take, filter } from 'rxjs/operators';

@Component({
	selector: 'hedou-m-scripts-init',
	templateUrl: './scripts-init.component.html',
})
export class ScriptsInitComponent implements OnInit, AfterViewInit, OnDestroy {
	asideSelfMinimizeToggle = false;
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	stylesLoaded$: any;
	constructor(
		private layout: LayoutService,
		private router: Router,
		private layoutState: LayoutStateService,
		private lazyLoadService: LazyLoadService) {
		this.lazyLoadStyle();
	}

	ngOnInit(): void {
		this.asideSelfMinimizeToggle = this.layout.getProp(
			'aside.self.minimize.toggle'
		);
		this.routingChanges();
	}

	ngAfterViewInit() {
		KTUtil.ready(() => {
			// Init Brand Panel For Logo
			KTLayoutBrand.init('kt_brand');
			// Init Aside
			KTLayoutAside.init('kt_aside');
			// Init Aside Menu
			KTLayoutAsideMenu.init('kt_aside_menu');

			if (this.asideSelfMinimizeToggle) {
				// Init Aside Menu Toggle
				KTLayoutAsideToggle.init('kt_aside_toggle');
			}

			// Init Sticky Card
			KTLayoutStickyCard.init('kt_page_sticky_card');
			// Init Stretched Card
			KTLayoutStretchedCard.init('kt_page_stretched_card');
		});
	}

	routingChanges() {
		const routerSubscription = this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
				const offCanvas = KTLayoutAside.getOffcanvas();
				if (offCanvas) {
					offCanvas.hide();
				}

				const btnQuickUserClose = document.getElementById('kt_quick_user_close');
				if (btnQuickUserClose) {
					btnQuickUserClose.click();
				}
			}
		});
		this.unsubscribe.push(routerSubscription);
	}

	ngOnDestroy() {
		this.unsubscribe.forEach((sb) => sb.unsubscribe());
	}

	lazyLoadStyle() {
		this.layoutState.get$('themeSettings')
			.pipe(take(1), filter(x => !!x && !!x.asideMenuColor))
			.subscribe((theme) => {
				console.log(theme.asideMenuColor)
				this.stylesLoaded$ = forkJoin(
					[
						// this.lazyLoadService.load(LOADING_STRATEGY.PrependAnonymousStyleToHead('/assets/metronic1/css/style.bundle.min.css')), 
						this.lazyLoadService.load(LOADING_STRATEGY.AppendAnonymousStyleToHead('/assets/global/plugins/keenthemes-icons/font/ki.css')),
						this.lazyLoadService.load(LOADING_STRATEGY.PrependAnonymousStyleToHead(`/assets/global/themes/layout/aside/${theme.asideMenuColor}.min.css`)),
						this.lazyLoadService.load(LOADING_STRATEGY.PrependAnonymousStyleToHead(`/assets/global/themes/layout/brand/${theme.brandColor}.min.css`)),
						this.lazyLoadService.load(LOADING_STRATEGY.PrependAnonymousStyleToHead(`/assets/global/themes/layout/header/base/${theme.headerColor}.min.css`)),
						this.lazyLoadService.load(LOADING_STRATEGY.PrependAnonymousStyleToHead(`/assets/global/themes/layout/header/menu/${theme.headerMenuColor}.min.css`))
					]
				).subscribe();

			});
	}
}
